import React, { useState } from 'react';
import { Calendar, Clock, MapPin, User, Trash2 } from 'lucide-react';
import { styles } from '../styles/styles.js';
import { getPriorityColor, getStatusColor, getWorkerName, filterTasks } from '../utils/utils.js';

const TasksPage = ({
    tasks,
    workers,
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    dateFilter,
    setDateFilter,
    onDeleteTask,
    onStatusChange
}) => {
    const filteredTasks = filterTasks(tasks, statusFilter, priorityFilter, dateFilter);
    const getWorkerName = (workerId) => {
        const worker = workers.find(w => w.id === workerId);
        return worker ? worker.name : "Unassigned";
    };
    const [hoveredTaskId, setHoveredTaskId] = useState(null);
    return (
        <div>
            {/* Filter Section */}
            <div style={styles.filterSection}>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '1rem' }}>Filter Tasks</h3>
                <div style={styles.filterGrid}>
                    <div>
                        <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Status:</label>
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={styles.filterInput}
                        >
                            <option>All Status</option>
                            <option>Pending</option>
                            <option>Active</option>
                            <option>Completed</option>
                        </select>
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Priority:</label>
                        <select
                            value={priorityFilter}
                            onChange={(e) => setPriorityFilter(e.target.value)}
                            style={styles.filterInput}
                        >
                            <option>All Priority</option>
                            <option>High</option>
                            <option>Medium</option>
                            <option>Low</option>
                        </select>
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>Date:</label>
                        <input
                            type="date"
                            value={dateFilter}
                            onChange={(e) => setDateFilter(e.target.value)}
                            style={styles.filterInput}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'end' }}>
                        <button
                            onClick={() => {
                                setStatusFilter('All Status');
                                setPriorityFilter('All Priority');
                                setDateFilter('');
                            }}
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                backgroundColor: '#f3f4f6',
                                color: '#374151',
                                border: 'none',
                                borderRadius: '0.5rem',
                                cursor: 'pointer'
                            }}
                        >
                            Clear Filters
                        </button>
                    </div>
                </div>
            </div>
{/*  */}
            {/* Tasks Grid */}
            <div style={styles.tasksGrid}>
                {filteredTasks.map(task => {
                    const statusColors = getStatusColor(task.status);
                    return (
                        <div key={task.id} style={styles.taskCard}>
                            <div style={styles.taskHeader}>
                                <h3 style={{ fontWeight: '600', color: '#111827', flex: 1 }}>{task.title}</h3>
                                <div style={styles.taskActions}>
                                    <span style={{
                                        ...styles.priorityBadge,
                                        backgroundColor: getPriorityColor(task.priority)
                                    }}>
                                        {task.priority}
                                    </span>
                                    <button
                                        onClick={() => onDeleteTask(task.id)}
                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626' }}
                                    >
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            </div>

                            {task.description && (
                                <>
                                    <p style={{
                                        color: '#6b7280',
                                        fontSize: '0.875rem',
                                        marginBottom: '1rem'
                                    }}>
                                        {task.description}
                                    </p>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: '#6b7280' }}>
                                            <MapPin style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                            <span>{task.location}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: '#6b7280' }}>
                                            <User style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                            <span>{getWorkerName(task.assignedTo)}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: '#6b7280' }}>
                                            <Calendar style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                            <span>{task.dueDate}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: '#6b7280' }}>
                                            <Clock style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                            <span>{task.estimatedTime} minutes</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span style={{ fontSize: '0.875rem', fontWeight: 500 }}>Status:</span>

                                                <span
                                                    style={{
                                                        padding: '0.25rem 0.75rem',
                                                        borderRadius: '9999px',
                                                        fontSize: '0.875rem',
                                                        fontWeight: 500,
                                                        backgroundColor:
                                                            task.status === 'completed' ? '#d1fae5' :
                                                                task.status === 'in-progress' ? '#fef3c7' :
                                                                    '#f3f4f6',
                                                        color:
                                                            task.status === 'completed' ? '#065f46' :
                                                                task.status === 'in-progress' ? '#92400e' :
                                                                    '#374151'
                                                    }}
                                                >
                                                    {task.status === 'in-progress' ? 'In Progress' : task.status.charAt(0).toUpperCase() + task.status.slice(1)}
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                </>
                            )}

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1rem' }}>
                                <div style={{ display: 'flex', gap: '0.5rem', marginTop: "1rem" }}>
                                    {task.status === 'pending' && (
                                        <button
                                            onClick={() => onStatusChange(task.id, 'active')}
                                            onMouseEnter={() => setHoveredTaskId(task.id)}
                                            onMouseLeave={() => setHoveredTaskId(null)}
                                            style={{
                                                padding: '0.75rem 0',
                                                backgroundColor: hoveredTaskId === task.id ? '#16a34a' : '#F9FAFB',
                                                color: hoveredTaskId === task.id ? 'white' : '#020817',
                                                border: 'none',
                                                borderRadius: '0.25rem',
                                                fontSize: '0.875rem',
                                                cursor: 'pointer',
                                                width: '100%',
                                                transition: 'background-color 0.2s, color 0.2s'
                                            }}
                                        >
                                            Start Task
                                        </button>
                                    )}

                                    {task.status === 'active' && (
                                        <button
                                            onClick={() => onStatusChange(task.id, 'completed')}
                                            onMouseEnter={() => setHoveredTaskId(task.id)}
                                            onMouseLeave={() => setHoveredTaskId(null)}
                                            style={{
                                                padding: '0.75rem 0',
                                                backgroundColor: hoveredTaskId === task.id ? '#16a34a' : '#F9FAFB',
                                                color: hoveredTaskId === task.id ? 'white' : '#020817',
                                                border: 'none',
                                                borderRadius: '0.25rem',
                                                fontSize: '0.875rem',
                                                cursor: 'pointer',
                                                width: '100%',
                                                transition: 'background-color 0.2s, color 0.2s'
                                            }}
                                        >
                                            Complete
                                        </button>
                                    )}

                                    {task.status === 'completed' && (
                                        <button
                                            onClick={() => onStatusChange(task.id, 'pending')}
                                            onMouseEnter={() => setHoveredTaskId(task.id)}
                                            onMouseLeave={() => setHoveredTaskId(null)}
                                            style={{
                                                padding: '0.75rem 0',
                                                backgroundColor: hoveredTaskId === task.id ? '#16a34a' : '#F9FAFB',
                                                color: hoveredTaskId === task.id ? 'white' : '#020817',
                                                border: 'none',
                                                borderRadius: '0.25rem',
                                                fontSize: '0.875rem',
                                                cursor: 'pointer',
                                                width: '100%',
                                                transition: 'background-color 0.2s, color 0.2s'
                                            }}
                                        >
                                            Mark Pending
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TasksPage;